import { useEffect, useRef } from 'react'
import { useAuth } from '@/hooks/AuthContext'
import toast from 'react-hot-toast'

const IdleTimer = () => {
  const { isAuthenticated, logout, sessionTimeout } = useAuth()
  const timerRef = useRef(null)

  const resetTimer = () => {
    if (timerRef.current) {
      clearTimeout(timerRef.current)
    }

    if (isAuthenticated && sessionTimeout > 0) {
      // sessionTimeout is in minutes, convert to milliseconds
      const timeoutMs = sessionTimeout * 60 * 1000

      timerRef.current = setTimeout(() => {
        handleLogout()
      }, timeoutMs)
    }
  }

  const handleLogout = () => {
    console.log(`🚪 Session expired due to inactivity (${sessionTimeout} minutes). Logging out...`)
    toast.error(
      `Your session has expired due to inactivity (${sessionTimeout} minutes). Please login again.`,
      {
        id: 'session-expired-idle-toast',
        duration: 5000
      }
    )

    // Clear session and redirect
    logout()
    // Using window.location.href to ensure redirect works even if outside Router context
    window.location.href = '/login?expired=true'
  }

  useEffect(() => {
    const events = ['mousedown', 'mousemove', 'keydown', 'scroll', 'touchstart', 'click']

    const handleActivity = () => {
      resetTimer()
    }

    if (isAuthenticated) {
      resetTimer()
      events.forEach(event => document.addEventListener(event, handleActivity))
    } else {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
    }

    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current)
      }
      events.forEach(event => document.removeEventListener(event, handleActivity))
    }
  }, [isAuthenticated, sessionTimeout])

  return null
}

export default IdleTimer
